import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ClientReceivables from "../components/ClientReceivables";
import ReportBranchPicker from "../components/ReportBranchPicker";
import useCurrentUser from "../hooks/useCurrentUser";
import { hasPermission } from "../utils/permissions";

const ReportsReceivablesPage = () => {
  const { branchId: routeBranchId } = useParams();
  const storedScope = localStorage.getItem("reportBranchScope");
  const defaultBranchScope =
    storedScope || routeBranchId || localStorage.getItem("selectedBranchId") || "";
  const [branchScopeId, setBranchScopeId] = useState(defaultBranchScope);
  const { user } = useCurrentUser();
  const canSelectBranch = hasPermission(user, "branch.access.any");

  useEffect(() => {
    if (branchScopeId) {
      localStorage.setItem("reportBranchScope", branchScopeId);
    }
  }, [branchScopeId]);

  useEffect(() => {
    if (!canSelectBranch && branchScopeId === "all") {
      const fallback = localStorage.getItem("selectedBranchId") || "";
      setBranchScopeId(fallback);
    }
  }, [canSelectBranch, branchScopeId]);

  return (
    <div className="bg-gray-100 min-h-screen">
      {canSelectBranch && (
        <div className="max-w-6xl mx-auto px-6 pt-6">
          <ReportBranchPicker
            value={branchScopeId}
            onChange={setBranchScopeId}
            className="w-full"
          />
        </div>
      )}
      <ClientReceivables branchScopeId={branchScopeId} />
    </div>
  );
};

export default ReportsReceivablesPage;
